import React, { Component } from 'react';
import lang from 'i18next';



class Tour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.id ?? '',
      type: props.type ?? 'video'
    };
  }


  static getDerivedStateFromProps(props) {
    return {
      id: props.id ?? '',
      type: props.type ?? 'video'
    }
  }


  render() {
    if(global.userSubStatus === 'trialing' || global.userSubPlan === 'spark') {
      if(this.state.type === 'video') {
        return <div className="btn-news prominent" onClick={() => this.props.clickVideo()}><img src='/img/tour-video.svg' alt='Watch'/>{lang.t('common:label.watchoverviewvideo')}</div>
      } else {
        return <div className="btn-news prominent" onClick={() => window.Intercom('startTour', this.state.id)}><img src='/img/tour-tour.svg' alt='Watch'/>{lang.t('common:label.showmearound')}</div>
      }
    } else {
      if(this.state.type === 'video') {
        return <div className="btn-news" onClick={() => this.props.clickVideo()}>{lang.t('common:label.watchoverviewvideo')}</div>
      } else {
        return <div className="btn-news" onClick={() => window.Intercom('startTour', this.state.id)}>{lang.t('common:label.showmearound')}</div>
      }
    }
  }
}


export default Tour;